import { render, staticRenderFns } from "./LearningOutcomeSearch.vue?vue&type=template&id=39cd9e0e"
import script from "./LearningOutcomeSearch.vue?vue&type=script&lang=js"
export * from "./LearningOutcomeSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports